import { useState } from "react";
import { motion } from "framer-motion";
import usePWAInstallPrompt from "./usePWAInstallPrompt";
import "./InstallBanner.css";

const InstallBanner = () => {
  const { canInstall, triggerInstall, dismissPrompt } = usePWAInstallPrompt();
  const [visible, setVisible] = useState(true);

  if (!canInstall || !visible) return null;

  return (
    <motion.div
      className="install-modal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="install-content"
        initial={{ scale: 0.7 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 20 }}
      >
    <button className="close-btn" onClick={dismissPrompt} aria-label="Close">
  <svg width="28" height="28" fill="none" viewBox="0 0 24 24" className="close-icon">
   <path
  d="M6 18L18 6M6 6l12 12"
  stroke="white"
  strokeWidth="3"
/>

  </svg>
</button>



        <img
          src="/icons/icon-192x192.png"
          alt="Kashmir Jobs Logo"
          className="install-logo"
        />

        <h2>📱 Install Kashmir Jobs</h2>
        <p>Access job listings anytime from your device just like an app!</p>
        <button className="install-btn" onClick={triggerInstall}>
          Install Now
        </button>
      </motion.div>
    </motion.div>
  );
};

export default InstallBanner;
